import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { generatePath, Link, useParams } from "react-router-dom"
import CreateKnowmix from "../../../../knowmix/createKnowmix"
import {
  clearGroupKnowmixList,
  getGroupKnowmixList,
} from "../../../../../../library/store/actions/creators/groupsCreators"
import MoreDropdown from "../../../../../../components/ui/dropdowns/moreDropdown"
import VerticalMenu from "../../../../../../components/ui/verticalMenu"
import {
  calendarGrades,
  grades as gradesNames,
  subjects as subjectsName,
} from "../../../../../../library/constants/educationalDictionary"
import * as routes from "../../../../../../library/constants/routes"
import logoDefault from "../../../../../../assets/img/product.svg"
import { safeGetEntity } from "../../../../../../library/utils/entities"
import { getObjectById } from "../../../../../../library/utils/arrays"
import * as _ from "lodash"
import ListPage from "../../../../../../components/v2/layout/listPage/listPage"
import KnowMixSquareCard from "../../../../knowmix/knowmixCard/knowMixSquareCard"

const GroupSettingsKnowmix = () => {
  const dispatch = useDispatch()
  const params = useParams()

  const { knowmixList, knowmixListEndReached } = useSelector(
    ({ groups }) => groups
  )

  return (
    <ListPage
      title={"Courses"}
      creationButtonTitle={"Create Course"}
      noResultsLabel={"This group doesn't have created Courses yet"}
      getList={async ({ name, offset, searchParams: { grades } }) =>
        await dispatch(
          getGroupKnowmixList({
            name: name || undefined,
            group_id: parseInt(params.groupId, 10),
            school_grades: grades
              ? _.map(_.split(grades, ","), _.parseInt)
              : undefined,
            offset,
          })
        )
      }
      ListContainer={({ children }) => (
        <div className={`cards-container cards-container--square`}>
          {children}
        </div>
      )}
      clearList={() => dispatch(clearGroupKnowmixList())}
      list={knowmixList}
      listEndReached={knowmixListEndReached}
      getListItemComponent={({ item }) => (
        <KnowMixSquareCard
          knowmix={item}
          hasMenu={true}
          menuItems={[
            {
              path: generatePath(routes.KNOWMIX_SETTINGS, {
                knowmixId: item.id,
              }),
              label: "Edit KnowMix",
            },
          ]}
          linkUrl={generatePath(routes.KNOWMIX, {
            knowmixId: item.id,
          })}
          key={item.id}
        />
      )}
      getFormDialogComponent={({ open, onClose }) => {
        return <CreateKnowmix open={open} handleClose={onClose} />
      }}
    />
  )
}

const KnowmixListItem = ({ knowmix }) => {
  const menuItems = [
    {
      path: generatePath(routes.KNOWMIX_SETTINGS, {
        knowmixId: knowmix.id,
      }),
      label: "Edit KnowMix",
    },
  ]

  const linkUrl = generatePath(routes.KNOWMIX, {
    knowmixId: knowmix.id,
  })

  const knowmixLogo = knowmix.photo || logoDefault

  return (
    <div
      className="relative grid grid-rows-subgrid gap-2 rounded-[2px] shadow-card bg-white relative p-3"
      style={{ gridRow: "span 5" }}
    >
      <div className="absolute right-2 top-2 self-end text-black38">
        <MoreDropdown>
          <VerticalMenu
            menuItems={menuItems}
            classes={"more-dropdown-menu__list"}
          />
        </MoreDropdown>
      </div>
      <Link to={linkUrl} className="img-container">
        <img src={knowmixLogo} alt="" />
      </Link>
      <Link to={linkUrl} className="name">
        {knowmix.name}
      </Link>
      <table className="knowmix-card--square__info">
        <tbody>
          {!!safeGetEntity(knowmix.subject) && (
            <tr>
              <td className="knowmix-card--square__info-label pb4">
                <span>Subject:</span>
              </td>
              <td className="knowmix-card--square__info-value pb4">
                {`${
                  getObjectById(calendarGrades, knowmix.subject.grade).name
                } grade, ${knowmix.subject.name}`}
              </td>
            </tr>
          )}
          {!!knowmix?.subjects?.length && (
            <tr>
              <td className="knowmix-card--square__info-label pb4">
                <span>Subjects:</span>
              </td>
              <td className="knowmix-card--square__info-value pb4">
                <span>
                  {knowmix.subjects
                    .map((id) => subjectsName.find((s) => s.id === id).name)
                    .join(", ")}
                </span>
              </td>
            </tr>
          )}
          {!!knowmix?.grades?.length && (
            <tr>
              <td className="knowmix-card--square__info-label pb4">
                <span>Grades:</span>
              </td>
              <td className="knowmix-card--square__info-value pb4">
                <span>
                  {knowmix.grades
                    .map((id) => gradesNames.find((g) => g.id === id).name)
                    .join(", ")}
                </span>
              </td>
            </tr>
          )}
        </tbody>
      </table>
      {/*<div className='h-divider h-divider--vertical-margin'></div>*/}
      {/*<div className='knowmix-card--square__status'>*/}
      {/*  <span className='knowmix-card--square__status-value'>*/}
      {/*    {bottomLabel}*/}
      {/*  </span>*/}
      {/*</div>*/}
    </div>
  )
}

export default GroupSettingsKnowmix
